import React from "react";
import {Image} from 'react-bootstrap';

import "./PressRelease.css";


import icon_release from "../../asset/images/icon_release.webp";
import img_01 from "../../asset/images/img-01.png";
import img_02 from "../../asset/images/img-02.png";
import img_03 from "../../asset/images/img-03.png";

//新闻公告
class PressRelease extends React.Component {
  render() {
    return (
      <div className="release" id="release">
        <Image src={icon_release} className="release_img" />
        <div className="release_cards">
          <div className="release_card">
            <Image src={img_01} className="release_card_img" />
            <div className="release_card_word">
              <div className="release_card_title">涵智博雅|你好2021</div>
              <div className="release_card_rectangle"></div>
              <div className="release_card_content">
                2020年注定是不平凡的一年，从年初就一直笼罩着的疫情，小心翼翼的生活，让每个人都感觉如履薄冰...
              </div>
            </div>
          </div>
          <div className="release_card">
            <Image src={img_02} className="release_card_img" />
            <div className="release_card_word">
              <div className="release_card_title">涵智博雅|招贤纳士 职等你来</div>
              <div className="release_card_rectangle"></div>
              <div className="release_card_content">
                能源工程师<br/>别犹豫，就现在 ☞ 涵智博雅期待你的加入！...
              </div>
            </div>
          </div>
          <div className="release_card">
            <Image src={img_03} className="release_card_img" />
            <div className="release_card_word">
              <div className="release_card_title">涵智博雅|国庆中秋 双节同庆</div>
              <div className="release_card_rectangle"></div>
              <div className="release_card_content">
                中秋佳节，举国共赏同一轮明月。<br/>
                北京涵智博雅能源科技有限公司祝大家：双节快乐！
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default PressRelease
